import { createAsyncThunk } from '@reduxjs/toolkit'
import programService, {
  DiscardProgramRequest,
  UpdateProgramRequest,
  ToggleProgramVisibilityRequest,
} from 'services/programs'

export const getPrograms = createAsyncThunk(
  'programs/get-programs',
  programService.getPrograms
)
export const getProgramById = createAsyncThunk(
  'programs/get-program-by-id',
  programService.getProgramById
)

export const getProgramRegistrations = createAsyncThunk(
  'programs/get-program-registrations',
  programService.getProgramRegistrations
)

export const createProgram = createAsyncThunk(
  'programs/create-program',
  programService.createProgram
)

export const getProgramScheduleById = createAsyncThunk(
  'programs/get-program-schedule-by-id',
  programService.getProgramScheduleById
)

export const getPublicPrograms = createAsyncThunk(
  'programs/get-public-programs',
  programService.getPublicPrograms
)

export const discardProgram = createAsyncThunk(
  'programs/discard-program',
  async (args: DiscardProgramRequest, { rejectWithValue }) => {
    try {
      return await programService.discardProgram(args)
    } catch (err) {
      // product#586: capture the HTTP status so the slice's rejected handler
      // can tell a 403 (no permission) from other failures. Without this a
      // non-manager's 403 rejected silently (no toast) — the bug #586 fixes.
      const status = (err as { response?: { status?: number } })?.response
        ?.status
      return rejectWithValue({ status })
    }
  }
)

// product#615: toggle a program's player visibility. Reuses the metadata-update
// endpoint (POST /programs/<id>, be#205) — it accepts `visible` and is already
// staff/owner-manager-gated, so no dedicated toggle endpoint is needed. Captures
// the HTTP status so the slice can tell a 403 (no permission) from other failures.
export const toggleProgramVisibility = createAsyncThunk(
  'programs/toggle-visibility',
  async (args: ToggleProgramVisibilityRequest, { rejectWithValue }) => {
    try {
      return await programService.updateProgram({
        locationId: args.locationId,
        programId: args.programId,
        body: { visible: args.visible },
      })
    } catch (err) {
      const status = (err as { response?: { status?: number } })?.response
        ?.status
      return rejectWithValue({ status })
    }
  }
)

export const updateProgram = createAsyncThunk(
  'programs/update-program',
  async (args: UpdateProgramRequest, { rejectWithValue }) => {
    try {
      return await programService.updateProgram(args)
    } catch (err) {
      // product#169: capture the HTTP status so the slice's rejected handler
      // can tell a 403 (no permission) from other failures (mirrors
      // discardProgram — otherwise a non-manager's 403 would toast nothing).
      const status = (err as { response?: { status?: number } })?.response
        ?.status
      return rejectWithValue({ status })
    }
  }
)

